export default __webpack_public_path__ + "static/media/basic-pin-small-1.d45746d2.png";